import {
  computed,
  Injectable,
  resource,
  ResourceRef,
  signal,
  Signal,
} from '@angular/core';
import { BankDataId } from '@web/dtos';
import { IApiResponse } from '@web/shared-types';
import { firstValueFrom } from 'rxjs';
import { SubscriptionPaymentPreferenceGateway } from './subscription-payment-preference.gateway';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionPaymentPreferenceStore {
  private readonly gateway: SubscriptionPaymentPreferenceGateway =
    new SubscriptionPaymentPreferenceGateway();
  private readonly shouldLoad = signal(false);

  #subscriptionPaymentPreferenceResource: ResourceRef<
    IApiResponse<BankDataId> | undefined
  > = resource({
    params: () => this.shouldLoad() || undefined,
    loader: (): Promise<IApiResponse<BankDataId> | undefined> => {
      return firstValueFrom(this.gateway.get());
    },
  });

  readonly isLoading: Signal<boolean> = computed((): boolean =>
    this.#subscriptionPaymentPreferenceResource.isLoading()
  );
  readonly subscriptionPaymentPreference: Signal<BankDataId> = computed(
    (): BankDataId =>
      this.#subscriptionPaymentPreferenceResource.hasValue()
        ? (this.#subscriptionPaymentPreferenceResource.value()?.data ??
          ('' as BankDataId))
        : ('' as BankDataId)
  );

  loadSubscriptionPaymentPreference(): void {
    if (this.shouldLoad()) {
      this.reload();
      return;
    }
    this.shouldLoad.set(true);
  }

  updateSubscriptionPaymentPreference(bankDataId: BankDataId): void {
    firstValueFrom(this.gateway.save({ bankDataId })).then(() => {
      this.reload();
    });
  }

  reload(): void {
    this.#subscriptionPaymentPreferenceResource.reload();
  }
}
